import { Formatters } from '../modules'
import { FIELD_PAYMENT } from './_common'

export default {
  props: {
    state: {
      label: '状态',
      type: 'state',
      classes: 'collapsing',
    },
    date_start: {
      label: '开始日期',
      type: 'date',
      required: true,
    },
    date_end: {
      label: '结束日期',
      type: 'date',
      required: true,
    },
    rent_month: {
      label: '时长',
      type: 'number',
      formatter: Formatters.duration_months,
      required: true,
    },
    amount_due: {
      label: '应收金额',
      type: 'money',
    },
    amount_paid: {
      label: '实收金额',
      type: 'money',
      classes: 'hide-in-mobile',
    },
    management_fee: {
      label: '管理费',
      type: 'money',
    },
    network_fee: {
      label: '网络费',
      type: 'money',
    },
    payment_method: FIELD_PAYMENT(),
    time_created: {
      label: '建立时间',
      type: 'time',
    },
    note: {
      label: '备注',
      maxlength: 15,
      classes: 'collapsing hide-in-mobile',
    },
  },
  actions: {
    edit: {
      icon: 'pencil',
      tooltip: '编辑',
    },
  },
  layouts: {
    default: {
      layout: ['state',
        'date_start',
        'date_end',
        'rent_month',
        'amount_paid',
        'payment_method',
        'note',
      ],
    },
    detail: {
      layout: ['state',
        'date_start',
        'date_end',
        'rent_month',
        'amount_due',
        'amount_paid',
        'management_fee',
        'network_fee',
        'payment_method',
        'note',
        'time_created',
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./client/src/defines/rent.js